<div class="print-sheet" [class.print-sheet--regular]="layout() === 'regular'" [class.print-sheet--mandala]="layout() === 'mandala'">
  <header class="print-sheet__header">
    <h1 class="print-sheet__name" data-test-id="print-name">{{ name() }}</h1>
    @if (layout() === 'basic') {
      <!-- Basis: tekstkop zonder tegels (Steven 2026-10-22): vijf tegels met iconen passen niet rustig op één rij. -->
      <dl class="print-sheet__basics">
        @for (row of basics(); track $index) {
          @for (basic of row; track basic.key) {
            <div class="print-sheet__basic" data-test-id="print-basic" [attr.data-key]="basic.key">
              <dt>{{ basic.label }}</dt>
              <dd>{{ basic.value }}</dd>
            </div>
          }
        }
      </dl>
    } @else {
      @for (row of basics(); track $index) {
        <div class="print-sheet__tiles" data-test-id="print-basics-row">
          @for (basic of row; track basic.key) {
            <hd-property-tile
              data-test-id="print-basic"
              [attr.data-key]="basic.key"
              [icon]="basic.icon"
              [label]="basic.label"
            >{{ basic.value }}</hd-property-tile>
          }
        </div>
      }
    }
  </header>

  <main class="print-sheet__chart" [style.--mandala-chart-scale]="mandala()?.scale ?? null">
    @if (layout() === 'mandala' && mandala(); as wheel) {
      <hd-mandala-wheel
        class="print-sheet__wheel"
        data-test-id="print-mandala"
        [configuration]="configuration()"
        [colorConfig]="colorConfig()"
        [planetaryActivations]="allActivations()"
        [geometry]="wheel.geometry"
        [showZodiacRing]="true"
        [showQuarterRing]="true"
        [showIchingRing]="true"
        [showGodheadRing]="true"
        [showSliceCenterFill]="wheel.sliceCenterFill"
        [gateGlyphs]="wheel.gateGlyphs"
        [quarterColorVariant]="wheel.quarterColorVariant"
        [zodiacRingVariant]="wheel.zodiacRingVariant"
        [quarterTexts]="wheel.quarterTexts"
        [zodiacSignNames]="wheel.zodiacSignNames"
        [showSeasonMarkers]="false"
        [sliceCenterFillOpaque]="true"
        [hoverEffectsEnabled]="false"
        primaryGateAction="show-info"
        [contextMenuEnabled]="false"
      ></hd-mandala-wheel>
    }

    @if (layout() === 'regular' && renderState(); as state) {
      <div class="print-sheet__side print-sheet__side--design" data-test-id="print-side-design">
        <hd-planet-grid
          class="print-sheet__lps"
          [activations]="designActivations()"
          side="design"
          [renderState]="state"
          [colorConfig]="planetGridColorConfig()"
          [visualizationMode]="visualizationMode()"
          [oppositeActivations]="personalityActivations()"
          [allActivations]="allActivations()"
          [statsOverallRenderState]="state"
          [chironDesign]="chironDesign()"
          [chironPersonality]="chironPersonality()"
          [contextMenuEnabled]="false"
        ></hd-planet-grid>
      </div>
    } @else if (layout() === 'basic') {
      <hd-simple-planet-grid
        class="print-sheet__grid"
        [activations]="designActivations()"
        side="design"
        [colorConfig]="planetGridColorConfig()"
        [contextMenuEnabled]="false"
      ></hd-simple-planet-grid>
    }

    <hd-bodygraph-chart
      class="print-sheet__bodygraph"
      [configuration]="configuration()"
      [colorConfig]="colorConfig()"
      primaryGateAction="show-info"
      [contextMenuEnabled]="false"
      [channelHighlightEnabled]="false"
      [showCenterCheatSheet]="showCenterKeynotes()"
      (loadErrorChange)="onBodygraphLoadError($event)"
    ></hd-bodygraph-chart>

    @if (layout() === 'regular' && renderState(); as state) {
      <div class="print-sheet__side print-sheet__side--personality" data-test-id="print-side-personality">
        <hd-planet-grid
          class="print-sheet__lps"
          [activations]="personalityActivations()"
          side="personality"
          [renderState]="state"
          [colorConfig]="planetGridColorConfig()"
          [visualizationMode]="visualizationMode()"
          [oppositeActivations]="designActivations()"
          [allActivations]="allActivations()"
          [statsOverallRenderState]="state"
          [contextMenuEnabled]="false"
        ></hd-planet-grid>
        @if (conditioning(); as conditioningVm) {
          <hd-property-tile
            class="print-sheet__conditioning"
            data-test-id="print-conditioning"
            icon="magnet"
            [label]="conditioningVm.label"
          >
            <hd-primary-conditioning-value [vm]="conditioningVm" />
          </hd-property-tile>
        }
      </div>
    } @else if (layout() === 'basic') {
      <hd-simple-planet-grid
        class="print-sheet__grid"
        [activations]="personalityActivations()"
        side="personality"
        [colorConfig]="planetGridColorConfig()"
        [contextMenuEnabled]="false"
      ></hd-simple-planet-grid>
    }
  </main>

  <footer class="print-sheet__footer">
    <span class="print-sheet__brand">Mechanics in Motion</span>
    <span class="print-sheet__tagline">Empowerment through awareness</span>
    <span class="print-sheet__url">mechanicsinmotion.be</span>
  </footer>
</div>
